import * as tslib_1 from "tslib";
import { deleteNotice, getPageNotice } from '@/services/menu';
import { timeFormat } from '@/shared/utils';
import { dispatch } from '@@/store';
import { useAntdTable } from 'ahooks';
import { Button, Popconfirm, Table } from 'antd';
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
const Root = styled.div `
  margin: 16px;
  padding: 16px;
  background-color: #fff;
`;
const DeployCarousel = ({ className, style, }) => {
    const confirmDelete = (id) => {
        deleteNotice(id).promise.then(() => refresh());
    };
    const columns = [
        {
            title: '公告名称',
            dataIndex: 'name',
            key: 'name',
            width: '20%',
        },
        {
            title: '公告内容',
            dataIndex: 'content',
            key: 'content',
            ellipsis: true,
            width: '30%',
        },
        {
            title: '通知生效时间',
            dataIndex: 'noticeStartDate',
            width: '10%',
            render: (text) => {
                return moment(text).format(timeFormat.dayFormat);
            },
        },
        {
            title: '通知失效时间',
            dataIndex: 'noticeExpireDate',
            width: '10%',
            render: (text) => {
                return moment(text).format(timeFormat.dayFormat);
            },
        },
        {
            title: '创建人',
            dataIndex: 'createName',
            width: '10%',
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            render: (text) => {
                return moment(text).format(timeFormat.dayFormat);
            },
            width: '10%',
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: '10%',
            render: (id, record) => {
                if (record.deleted) {
                    return <span>已删除</span>;
                }
                else {
                    return (<span>
              <a style={{ marginRight: '10px' }} onClick={() => {
                        localStorage.setItem('curEditCarousel', JSON.stringify(record));
                        dispatch.router.push({
                            path: '/deployCarousel/createOrEdit',
                            query: {
                                id: String(id),
                            },
                        });
                    }}>
                编辑
              </a>
              <Popconfirm title="确定删除这个公告吗?" onConfirm={() => confirmDelete(id)} okText="Yes" cancelText="No">
                <a href="#">删除</a>
              </Popconfirm>
            </span>);
                }
            },
        },
    ];
    const getMyLibraryPage = (params) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield getPageNotice(params.current, params.pageSize).promise;
    });
    const { tableProps, refresh } = useAntdTable(getMyLibraryPage, {
        defaultPageSize: 10,
        formatResult: (res) => {
            return {
                total: res.totalNumber,
                list: res.items,
            };
        },
    });
    return (<Root className={className} style={style}>
      <Button type="primary" onClick={() => {
        dispatch.router.push('/deployCarousel/createOrEdit');
    }}>
        新增公告
      </Button>
      <Table rowKey={'id'} columns={columns} {...tableProps}/>
    </Root>);
};
export default DeployCarousel;
